import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast
} from "@chakra-ui/react";
import { partial } from "filesize";
import { useFormik } from "formik";
import { useRef, useState } from "react";
import SponsorService from "../../../services/admin/sponsors.service";

export const PayBudgetModal: React.FC<any> = ({
  isOpenPay,
  onClosePay,
  isPay = false,
  budgetId,
  reload,
}: {
  isPay: boolean;
  isOpenPay: any;
  onClosePay: any;
  budgetId: string;
  reload: any;
}) => {
  const toast = useToast();
  const cancelRef = useRef().current;
  const inputRef = useRef<HTMLInputElement | null>(null);

  const [logoFile, setlogoFile] = useState<File | null>(null);
  const [batchFile, setbatchFile] = useState<FormData | null>(null);
  const [filename, setFilename] = useState("");
  const [uploadFileSize, setUploadFileSize] = useState("");
  const [preview, setPreview] = useState<string | undefined>();

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value) {
      const fileName = e.target.files?.item(0)?.name as string;

      const fileType = e.target.files?.item(0)?.type;
      const file = e.target.files?.item(0) as File;
      
      if (fileType?.split("/").at(0) !== "image") {
        // formik.setErrors({ certificate: 'Only PDF,jpg,png file format is supported' });
        return;
      }
      setFilename(fileName);
      setlogoFile(file);
      const fileSize = partial({ base: 2, standard: "jedec" });
      setUploadFileSize(fileSize(file.size));
    } else {
      setFilename("");
      setlogoFile(null);
    }
    formik.handleChange(e);
  };

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.amount) {
        errors.amount = "amount  required";
      }
      if (!values.channel) {
        errors.channel = "please signify payment mode";
      }

      return errors;
    },
    initialValues: {
      amount: "",
      channel: "",
    },
    onSubmit: async (values) => {
      try {
        if (logoFile) {
            const formDataa = new FormData();
            const file = logoFile;
            formDataa.append("proof_of_payment   ", file);
            formDataa.append("amount", values.amount);
            formDataa.append("channel", values.channel);
            const payBudget = await SponsorService.payBudget(budgetId, formDataa);
        

        if (payBudget) {
            setFilename("");
            setlogoFile(null);
          toast({
            title: "Budget Payment",
            description: "Budget successfully credited",
            status: "success",
            duration: 2000,
            onCloseComplete: () => onClosePay(),
          });
          reload();
        }
          } 
      
      } catch (error: any) {
        toast({
          title: "Budget Payment",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpenPay && isPay}
        onClose={onClosePay}
        scrollBehavior="inside"
        closeOnOverlayClick={true}
        size="sm"
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={4}>
          <ModalHeader>
            {
              <Text
                fontSize="21px"
                fontWeight="700"
                pb={1}
                textTransform="none"
                pl={3}
                color="#2B2B2B"
              >
                Pay Budget
              </Text>
            }
          </ModalHeader>
          <ModalCloseButton size="sm" />
          <ModalBody pb={3}>
            <Box mt={1}>
              <form onSubmit={formik.handleSubmit}>
                <FormControl
                  mt={3}
                  isInvalid={
                    formik.errors.amount && formik.touched.amount ? true : false
                  }
                >
                  <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                    Amount
                  </FormLabel>
                  <InputGroup>
                    <InputLeftElement
                      color="brand.subtitle"
                      pointerEvents="none"
                      children={<Text>₦</Text>}
                    />

                    <Input
                      type="number"
                      id="amount"
                      name="amount"
                      placeholder="Enter amount"
                      onChange={formik.handleChange}
                      fontSize={13}
                    />
                  </InputGroup>

                  <FormErrorMessage fontSize={12}>
                    {formik.errors.amount}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  mt={3}
                  isInvalid={
                    formik.errors.channel && formik.touched.channel
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                    Channel:{" "}
                  </FormLabel>
                  <Input
                    type="text"
                    id="channel"
                    name="channel"
                    placeholder="Enter payment channel"
                    onChange={formik.handleChange}
                    fontSize={13}
                  />

                  <FormErrorMessage fontSize={12}>
                    {formik.errors.channel}{" "}
                  </FormErrorMessage>
                </FormControl>
               
                <FormControl mt={3} mr={10}>
                  <FormLabel fontWeight="600" color="#616161" fontSize={13}>
                    Upload proof of payment
                  </FormLabel>
                  <Text fontWeight="400" color="#959595" fontSize="14px">
                    Upload an image of the proof. (Not larger than 2MB)
                  </Text>

                  <input
                    accept="image/*"
                    type="file"
                    name="certificateFile"
                    ref={inputRef}
                    onChange={(e) => handleFileChange(e)}
                    style={{ display: "none" }}
                  ></input>
                  <Input
                    cursor="pointer"
                    placeholder="No file selected"
                    defaultValue={filename}
                    mt="10px"
                    borderColor="#eeeeee"
                    fontSize={14}
                    bg="#fafafa"
                    onClick={() => inputRef?.current?.click()}
                    border="2px dashed"
                    borderRadius={2}
                  />
                </FormControl>
                {filename && (
                  <Box  mt="10px" mb="10px">
                    <Text>{filename}</Text>
                  </Box>
                )}
                <Flex mt={12} justifyContent="end">
                  <HStack>
                    <Button
                      size="sm"
                      px={6}
                      fontSize={12}
                      ref={cancelRef}
                      onClick={() => onClosePay()}
                    >
                      Cancel
                    </Button>
                    <Button
                      colorScheme="red"
                      type="submit"
                      isLoading={formik.isSubmitting}
                      size="sm"
                      px={6}
                      fontSize={12}
                    >
                      {" "}
                      Pay
                    </Button>
                  </HStack>
                </Flex>
              </form>
            </Box>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
